import dayjs from "dayjs";

export const formatDate = (date) => dayjs(date).format("YYYY-MM-DD");
export const formatMonthDate = (date) => date.format("YYYY-MM");
